import type {IconName} from '@vio/atlas/Icon'

/**
 * Maps bed type IDs to their corresponding icon names based on design.
 */
const BED_TYPE_ICON_MAP: Record<string, IconName> = {
  'bunk bed': 'FamilyRoom',
  'female capsule': 'CapsuleBed',
  'full bed': 'DoubleBed',
  'futon bed': 'FutonBed',
  'king bed': 'DoubleBed',
  'male capsule': 'CapsuleBed',
  'murphy bed': 'Checkmark',
  'queen bed': 'DoubleBed',
  'small double bed': 'SingleBed',
  'sofa bed': 'SofaBed',
  'trundle bed': 'Checkmark',
  'twin bed': 'SingleBed',
  'water bed': 'Checkmark'
}

/**
 * Returns the appropriate icon name for a given bed type ID.
 * Falls back to 'Checkmark' if no specific mapping exists.
 */
export const getBedTypeIcon = (typeID?: string): IconName => {
  const iconName = BED_TYPE_ICON_MAP[typeID || '']
  if (!typeID || !iconName) return 'Checkmark'
  return iconName
}
